export default {
    companies: [],
    companyId: null
};
